import axios from 'axios';

const instance = axios.create({
    
    // baseURL:'https://localhost:44339/'
     baseURL:'/API/'

    // baseURL:'http://betacico.babjisoftech.com/API/'
    // baseURL:'https://admin.fayzetaheri.com/API/'
    // baseURL:'https://betamumbai.mazaraat.org/API/'
});

export default instance;
